export const upsertByGuid = <T extends { guid: string }>(
  list: readonly T[],
  item: T,
  prepend = false,
): T[] => {
  if (!item.guid) {
    return prepend ? [item, ...list] : [...list, item]
  }

  const i = list.findIndex((x) => x.guid === item.guid)

  if (i < 0) return prepend ? [item, ...list] : [...list, item]

  const next = [...list]
  next[i] = item
  return next
}
